/** Static copy constants for deterministic issue-to-fix mapping (worker reads these). */
export const FIX_KIT_RECOMMENDATION_BY_CHECK_ID = {
    "surface-quality.language-hygiene": {
        priority: "HIGH",
        recommendedFix: "Rewrite primary headings and service blurbs for plain, specific language.",
        rationale: "Language hygiene checks flagged unclear or generic copy that weakens AI and search understanding.",
        clientFacingLanguage: "We recommend tightening homepage and service copy so visitors (and AI assistants) understand what you offer within seconds.",
        ownershipHint: "SHARED",
    },
    "surface-quality.lead-path-reachable": {
        priority: "HIGH",
        recommendedFix: "Add a visible contact path above the fold (phone, form, or booking link).",
        rationale: "Lead-path checks could not confirm an obvious way for visitors to reach the business.",
        clientFacingLanguage: "Make it easy to contact you — add a clear call-to-action with phone, form, or scheduling link near the top of the page.",
        ownershipHint: "CLIENT",
    },
    "surface-quality.demo-quality": {
        priority: "MEDIUM",
        recommendedFix: "Add trust signals: testimonials, certifications, or portfolio examples with context.",
        rationale: "Demo-quality checks found weak trust or placeholder-style presentation.",
        clientFacingLanguage: "Strengthen trust on your site with real examples, reviews, or credentials that match your services.",
        ownershipHint: "SHARED",
    },
    "surface-quality.claim-evidence": {
        priority: "MEDIUM",
        recommendedFix: "Support marketing claims with specific evidence or qualify broad statements.",
        rationale: "Claim-evidence checks flagged statements that may read as unsubstantiated.",
        clientFacingLanguage: "Review bold claims on your site and add supporting detail or soften wording where evidence is thin.",
        ownershipHint: "AGENCY",
    },
    "external-scan.schema-hints": {
        priority: "HIGH",
        recommendedFix: "Add title, meta description, and basic structured data (Organization or LocalBusiness).",
        rationale: "Metadata and schema-hint checks found missing or weak machine-readable page signals.",
        clientFacingLanguage: "Improve page titles, descriptions, and structured data so search engines and AI tools can summarize your business accurately.",
        ownershipHint: "AGENCY",
    },
};
export const FIX_KIT_NEXT_STEP_PROPOSAL = "Share this Fix Kit with the site owner, agree on scope, then track manual pilot payment before deeper implementation work.";
//# sourceMappingURL=fix-kit-copy.js.map